import { NgModule } from '@angular/core';
import { SpacedNumberPipe } from './spaced-number.pipe';

@NgModule({
    declarations: [SpacedNumberPipe],
    exports: [SpacedNumberPipe],
})
export class SpacedNumberPipeModule {}
